import { FC, ReactNode } from 'react';
import { CardMedia } from '@mui/material';
import { Card as MuiCard } from '@wellstone-solutions/web';

import logo from '@assets/recovery-collective.png';

import type { HarborTheme } from '@/themes/types';

interface CardProps {
  children: ReactNode;
}

const Card: FC<CardProps> = (props) => {
  const { children } = props;

  return (
    <MuiCard sx={styles.card}>
      <CardMedia component="img" image={logo} title="Logo" sx={styles.logo} />
      {children}
    </MuiCard>
  );
};

const styles = {
  card: {
    borderRadius: (theme: HarborTheme) => theme.shape.borderRadius,
    boxShadow: 8,
    padding: {
      xs: '2rem 0',
      sm: '2rem',
    },
    width: {
      xs: '100%',
      sm: '520px',
    },
  },
  logo: {
    height: 32,
    width: '100%',
    objectFit: 'contain',
    objectPosition: 'center',
  },
};

export { Card };
